import React from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import {
    Radio,
    RadioGroup,
    FormControl,
    FormControlLabel,
    FormLabel,
} from '@mui/material';
import { ErrorMessage } from './ErrorMessage';
import { requiredUtil } from '../utils';

const style = {
    marginBottom: '20px',
};

const GenericRadioGroupField = ({
    name,
    label,
    required,
    options = [],
    size,
}) => (
    <Field name={name} validate={required ? requiredUtil : undefined}>
        {({ input, meta }) => (
            <div>
                <FormControl>
                    <FormLabel>{label}</FormLabel>
                    <RadioGroup
                        value={input.value}
                        {...input}
                        data-testid={name}
                    >
                        {options.map((option) => (
                            <div
                                className="flex items-center"
                                style={style}
                                key={option.value}
                            >
                                <FormControlLabel
                                    value={option.value}
                                    control={<Radio size={size} />}
                                />
                                <div>{option.label}</div>
                            </div>
                        ))}
                    </RadioGroup>
                </FormControl>
                <ErrorMessage meta={meta} />
            </div>
        )}
    </Field>
);

GenericRadioGroupField.propTypes = {
    name: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    required: PropTypes.bool,
    options: PropTypes.array,
    size: PropTypes.string,
};

export default GenericRadioGroupField;
